import { App } from 'vue'
import VueObserveVisibility from 'vue3-observe-visibility'

export default {
  install(app: App<Element>) {
    app.use(VueObserveVisibility)
  }
}